module.exports = __webpack_public_path__ + "static/GNT0-8c2758c9930924a0f3b3bee3cb64a64d.jpg";